import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { LoginGuard } from './login/login.guard';
import { InfodownloadComponent } from './argic/view/infodownload/infodownload.component';
import { DatadownloadComponent } from './argic/view/datadownload/datadownload.component';
import { GeneralinfoComponent } from './argic/view/generalinfo/generalinfo.component';
import { SettingsComponent } from './argic/view/settings/settings.component';
import { ContactComponent } from './website/contact/contact.component';
import { MyargicComponent } from './website/myargic/myargic.component';
import { TechnicalcommitteeComponent } from './argic/view/technicalcommittee/technicalcommittee.component';
import { MatrixSearchWrapperComponent } from './argic/view/matrixsearch-wrapper.component';
import { ChangeRequestDiscussionComponent } from './argic/view/change-request-discussion/change-request-discussion.component';
import { MyChangeRequestsComponent } from './argic/view/my-change-requests/my-change-requests.component';


@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '',
                component: AppMainComponent,
                children: [
                    { path: 'matrixsearch', component: MatrixSearchWrapperComponent, /*canActivate: [LoginGuard] */ },
                    { path: 'change-request-discussion', component: ChangeRequestDiscussionComponent, /*canActivate: [LoginGuard]*/ },
                    { path: 'my-change-requests', component: MyChangeRequestsComponent, /*canActivate: [LoginGuard]*/ },
                    { path: 'settings', component: SettingsComponent, /*canActivate: [LoginGuard]*/ },
                    { path: 'download/info', component: InfodownloadComponent, /*canActivate: [LoginGuard]*/ },
                    { path: 'download/data', component: DatadownloadComponent, /*canActivate: [LoginGuard]*/ },
                    // { path: 'generalinfo', component: GeneralinfoComponent, /*canActivate: [LoginGuard],*/ },
                    { path: 'login', component: AppLoginComponent },
                    { path: 'myargic', /*canActivate: [LoginGuard],*/ component: MyargicComponent },
                    { path: 'technicalcommittee', canActivate: [LoginGuard], component: TechnicalcommitteeComponent },
                    { path: 'register', component: ContactComponent },
                ]
            },
            { path: 'error', component: AppErrorComponent },
            { path: 'access', component: AppAccessdeniedComponent },
            { path: 'notfound', component: AppNotfoundComponent },
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload', initialNavigation: 'enabledNonBlocking' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

